import styled from 'styled-components';
import img from 'lib/assets/images/login-background.jpg';
import { Link } from 'react-router-dom';
import { brand } from 'themes/brand';

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;

  .leftSide {
    width: 55%;
    height: 100vh;
    position: relative;
    overflow: hidden;

    /* A arte cobre todo o painel. O filtro escurece os tons escuros, como no
       mockup, sem apagar os textos brancos. Ancorada no topo à esquerda para
       preservar logo e título quando a proporção da tela exige recorte. */
    ::before {
      content: '';
      position: absolute;
      inset: 0;
      background-image: url(${img});
      background-repeat: no-repeat;
      background-position: left top;
      background-size: cover;
      filter: brightness(0.85) contrast(1.15);
    }
  }

  .rightSide {
    width: 45%;
    height: 100vh;
    background-color: ${brand.surface};
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: solid 1px ${brand.border};
  }

  .rightSide > section {
    border: 1px solid ${brand.border};
    box-shadow: 0 8px 24px rgba(11, 19, 36, 0.08);
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap-reverse;
  gap: 30px;

  h3 {
    margin: 0;
    line-height: 0;
    color: ${brand.text};
  }

  p {
    margin: 0;
    color: ${brand.textSecondary};
  }

  button {
    width: 100%;
  }
`;

export const ErrorMsg = styled.p`
  color: #fb5454 !important;
  font-size: 12pt;
`;

export const StyledLink = styled(Link)`
  color: ${brand.primary};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  align-self: end;
  &:hover {
    color: ${brand.primaryDark};
  }
`;

export const CenteredParagraph = styled.p`
  text-align: center;
  color: ${brand.textSecondary};
  padding-top: 10px;
`;

export const HorizontalBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  padding-top: 10px;

  button {
    color: ${brand.text};
    border-color: ${brand.border};
  }

  button svg {
    color: ${brand.primary};
  }
`;

export const CircularLoadingBox = styled.div`
  display: flex;
  justify-content: center;
`;
